export default "__VITE_ASSET__Bgx1nM5P__"